import { RolesDomain } from 'core/typing/domains/RolesDomain/RolesDomain';
import { createEvent } from 'effector';

export const loadRoles = createEvent('loadRoles');
export const loadRolesDone = createEvent<RolesDomain>('loadRolesDone');
export const loadRolesFail = createEvent('loadRolesFail');
